import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import SwipeableViews from 'react-swipeable-views';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CancelIcon from '@mui/icons-material/Cancel';
import { useTranslation } from "react-i18next";

export default function MaxWidthDialog({ open, setOpen, data }) {
  const [activeIndex, setActiveIndex] = React.useState(0);
  const { t } = useTranslation();
  React.useEffect(()=>{
    setActiveIndex(0)
  },[])
  const handleChangeIndex = (index) => {
    setActiveIndex(index);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleNext = () => {
    setActiveIndex((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveIndex((prevActiveStep) => prevActiveStep - 1);
  };
  return (
    <React.Fragment>
      <Dialog open={open} onClose={handleClose}
      sx={{ '.MuiPaper-root':{bgcolor:'#FAF8F8',borderRadius:'20px'} }}>
            <DialogActions>
          <Button onClick={handleClose} >
            <CancelIcon sx={{ color:'#20C4F0' }}/>
          </Button>
        </DialogActions>
        <DialogContent>
          <SwipeableViews index={activeIndex} onChangeIndex={handleChangeIndex}>
            {data.images.map((image, index) => (
              <Box key={index} sx={{ display:'flex',flexWrap:'wrap' ,justifyContent: 'center',
              alignItems: 'center' }}>
                <img src={image} alt={`Image ${index + 1}`} style={{ width: '100%',
                objectFit:'contain',height:'350px',borderRadius:'20px' }} />
              </Box>
            ))}
          </SwipeableViews>
          <DialogContentText sx={{ marginTop:'30px',fontWeight:'bold',fontSize:'20px',color:'#20C4F0' ,display:'flex',flexWrap:'wrap' ,justifyContent: 'center',
                alignItems: 'center'}}
          >{t(data.title)}</DialogContentText>
          <DialogContentText sx={{ color:'black',marginBottom:'30px',
        display:'flex',flexWrap:'wrap' ,justifyContent: 'center',
        alignItems: 'center' }}>{t(data.description)}</DialogContentText>

          <div style={{ position: 'absolute',bottom:'40%' }}>
    <Button sx={{ borderRadius: '100px', height: '30px',
     color: '#20C4F0', margin: "10px" }}
              size="small"
              onClick={handleNext}
              disabled={activeIndex === data.images.length - 1}
          >
              <ArrowBackIosIcon />
          </Button>
          </div>
          <div style={{ position: 'absolute',bottom:'40%',right:'30px' }}>
          <Button
              sx={{  borderRadius: '100px', color: '#20C4F0',
               height: '30px', margin: "10px" }}
              size="small" onClick={handleBack} disabled={activeIndex === 0}>
                  <ArrowForwardIosIcon />
              </Button>
              </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}